import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../consts/api";

export const useUpgradePrescriber = (options = {}) => {
  const res = useMutation(
    (dto) => http.post(HTTP_ENDPOINTS.prescribers.upgradePrescriber(), dto),
    { ...options },
  );
  return res;
};
